<div class="basic-background" [contextMenu]="basicMenu" [contextMenuSubject]="mailInfo">

  <div class="sticky_header" [ngStyle]="{'top': stickyHeaderOffset}">
    <div class="offer-status-tag" (click)="clickPart(0)" [style.padding-bottom]="isOfferPage()? '5px':'10px'">
      <app-card-offer-page-header *ngIf="isOfferPage()" [mailInfo]="mailInfo" [mailType]="mailType" [page]="page"
        [offer]="offer" [actionLog]="actionLog"
        [haveSkillList]="mailInfo.attached_files&&mailInfo.attached_files[0]?.total_working_months">
      </app-card-offer-page-header>
    </div>
    <app-card-header-title [mailInfo]="mailInfo" [mailType]="mailType" [baseKeywords]="baseKeywords"
      [sharedAccountOffers]="sharedAccountOffers" [offeredMailIds]="offeredMailIds" [page]="page"
      [showTooltip]="displayStatus > 0" [rejectReason]="rejectReason"
      [haveSkillList]="mailInfo.attached_files&&mailInfo.attached_files[0]?.total_working_months"
      [searchParams]="searchParams" (click)="clickPart(0)">
    </app-card-header-title>

    <div class="position-relative" *ngIf="displayStatus>0">
      <app-card-header-info [mailInfo]="mailInfo" [pairMail]="pairMail" [mailType]="mailType"
        [baseKeywords]="baseKeywords" [editEvent]="cardHeaderEditEvent" [page]="page" [rejectReason]="rejectReason"
        (click)="clickPart(1)" (deleted)="deleted.emit()">
      </app-card-header-info>
    </div>

    <div class="border-top border-bottom" *ngIf="displayStatus>1">
      <app-card-action-area [mailInfo]="mailInfo" [pairMail]="pairMail" [workerMail]="workerMail"
        [projectMail]="projectMail" [offerType]="offerType" [mailType]="mailType" [editEvent]="cardHeaderEditEvent"
        [page]="page" [actionLogId]="actionLogId" [actionLogForOffer]="actionLog" [offer]="offer" [result]="result"
        (deleted)="deleted.emit()" (click)="clickPart(2)" (changeStatus)="changeStatus.emit($event)">
      </app-card-action-area>
    </div>
    <!-- 閉じるボタン -->
    <button *ngIf="isIndexPage()" (click)="onCloseButtonClick()" class="close-detail-box">
      <i class="fa fa-angle-double-right"></i>
    </button>
  </div>

  <ng-container *ngIf="displayStatus>2">
    <app-card-detail-info [mailInfo]="mailInfo" [pairMail]="pairMail" [baseKeywords]="baseKeywords"
      [workerMail]="workerMail" [page]="page" [projectMail]="projectMail" [baseMailType]="mailType"
      [rejectReason]="rejectReason" [searchParams]="searchParams" (click)="clickPart(3)">
    </app-card-detail-info>
    <div class="padding-top-bottom">
      <app-card-skillsheet-info [mailInfo]="mailInfo" [files]="mailInfo.attached_files" [searchParams]="searchParams">
      </app-card-skillsheet-info>
    </div>
  </ng-container>
</div>

<!-- コンテキストメニュー -->
<context-menu #basicMenu>
  <ng-template contextMenuItem (execute)="openTagRegister()">
    <i class="fa fa-tags margin-right-5"></i>タグを編集
  </ng-template>
  <ng-template contextMenuItem (execute)="
                        copyService.copyToClipboard(copyService.selectedText())
                      ">
    <i class="fa fa-clipboard margin-right-5"></i>選択範囲をコピー
  </ng-template>
  <ng-template contextMenuItem (execute)="copyService.copyToClipboard(mailInfo.title)">
    <i class="fa fa-clipboard margin-right-5"></i>件名をコピー
  </ng-template>
  <ng-template contextMenuItem (execute)="copyService.copyToClipboard(mailInfo.mail_from)">
    <i class="fa fa-clipboard margin-right-5"></i>送信元をコピー
  </ng-template>
  <ng-template contextMenuItem (execute)="copyService.copyToClipboard(mailInfo.body)">
    <i class="fa fa-clipboard margin-right-5"></i>本文をコピー
  </ng-template>
  <ng-template contextMenuItem (execute)="
                        copyService.copyToClipboard(
                          leaveOnlyImportantLinePipe.transform(
                            mailInfo.body,
                            mailInfo
                          )
                        )
                      ">
    <i class="fa fa-clipboard margin-right-5"></i>メインパートをコピー
  </ng-template>
  <ng-template contextMenuItem (execute)="copyService.copyToClipboard(mailInfo.ai_mail_id)">
    <i class="fa fa-clipboard margin-right-5"></i>IDをコピー
  </ng-template>
  <ng-template contextMenuItem (execute)="sendToRegister()">
    <i class="fa fa-share-square-o margin-right-5"></i>案件人材管理に追加
  </ng-template>
  <ng-template *ngIf="mailInfo.work_location && pairMail?.work_location" contextMenuItem (execute)="
                        locationService.openMap(mailInfo, pairMail)">
    <i class="fa fa-map-pin margin-right-5"></i>経路を表示
  </ng-template>
</context-menu>